import { Card, CardContent, Tab, Tabs } from '@material-ui/core'
import React from 'react'
import { useIntl } from 'react-intl'
import TabPanel from '@material-ui/lab/TabPanel'
import TabContext from '@material-ui/lab/TabContext'
import PlaceDetails from './tabs/PlaceDetails'
import PlacePhotos from './tabs/PlacePhotos'
import FuseAnimateGroup from '@fuse/components/FuseAnimateGroup/FuseAnimateGroup'
import SubscribersPanel from 'app/main/contentPanel/SubscribersPanel'
import TeamMembersPreviewPanel from 'app/main/contentPanel/TeamMembersPreviewPanel'
import GroupsPanel from 'app/main/contentPanel/GroupsPanel'
import MainLayout from 'app/components/MainLayout'
import PlaceOpeningHours from 'app/main/profile/tabs/PlaceOpeningHours'
import PlaceLanding from 'app/main/profile/tabs/PlaceLanding'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  navBar: {
    '& .MuiTabs-scroller': {
      overflowY: 'hidden',
    },
  },
}))

export default ({ history }) => {
  const { formatMessage } = useIntl()
  const classes = useStyles()
  const [selectedTab, setTab] = React.useState('info')

  const handleTabChange = (event, newValue) => {
    setTab(newValue)
  }

  const PanelWrapper = (content) => {
    return <div className="mb-8">{content}</div>
  }

  return (
    <MainLayout
      isAutoOverflow={true}
      main={
        <>
          <Card elevation={1} className="flex-auto">
            <CardContent className="px-0 sm:px-10">
              <TabContext value={selectedTab}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="secondary"
                  textColor="secondary"
                  variant="scrollable"
                  scrollButtons="off"
                  className={clsx(
                    'h-64 w-full border-b-1 tabDefault',
                    classes.navBar,
                  )}
                >
                  <Tab
                    className="h-64 tabDefault"
                    value="info"
                    label={formatMessage({ id: 'profile.info' })}
                  />
                  <Tab
                    className="h-64 tabDefault"
                    value="photos"
                    label={formatMessage({ id: 'profile.info.photo' })}
                  />
                  <Tab
                    className="h-64 tabDefault"
                    value="hours"
                    label={formatMessage({ id: 'profile.info.hours' })}
                  />
                  <Tab
                    className="h-64 tabDefault"
                    value="landing"
                    label={formatMessage({ id: 'profile.info.landing' })}
                  />
                </Tabs>
                <TabPanel value="info" index="info" className="px-5">
                  <PlaceDetails />
                </TabPanel>
                <TabPanel value="photos" index="photos">
                  <PlacePhotos />
                </TabPanel>
                <TabPanel value="hours" index="hours">
                  <PlaceOpeningHours />
                </TabPanel>
                <TabPanel value="landing" index="landing">
                  <PlaceLanding />
                </TabPanel>
              </TabContext>
            </CardContent>
          </Card>
        </>
      }
      side={
        <div className="rtl:mr-16 ltr:ml-16">
          <FuseAnimateGroup
            enter={{ animation: 'transition.slideDownIn' }}
            leave={{ animation: 'transition.slideDownOut' }}
          >
            {PanelWrapper(<TeamMembersPreviewPanel history={history} />)}
            {PanelWrapper(<SubscribersPanel />)}
            {PanelWrapper(<GroupsPanel />)}
          </FuseAnimateGroup>
        </div>
      }
    />
  )
}
